// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"styles_footerLinks__Q_tFW","icon":"styles_icon__QxFjz","label":"styles_label__cVa_c","container":"styles_container__wODTp"};